function convertMsForYAxis(ms, floorRound, fullValue) {
    let seconds = Math.floor(+ms / 1000);
    let minutes,
        hours,
        days;

    let roundFn = floorRound ? Math.floor : Math.ceil;

    if (+ms < 1000) {
        return `${+(+ms / 1000).toFixed(2)}s`;
    }

    if (seconds === 0) {
        return 0;
    }

    if (seconds < 60) {
        return `${seconds}s`;
    }

    minutes = Math.ceil(seconds / 60);

    if (minutes < 60) {
        return `${minutes}m`;
    }

    hours = roundFn(minutes / 60);
    if (hours < 24) {
        if (minutes - hours * 60 > 0) {
            return `${hours}h ${minutes - hours * 60}m`;
        } else {
            return `${hours}h`;
        }
    }

    days = roundFn(hours / 24);

    if (hours % 24 !== 0 && fullValue) {
        return `${days}d ${hours % 24}h`;
    }

    return `${days}d`;
}


export default convertMsForYAxis;
